import React from 'react'

const NotificationDetailPage = () => {
  return <h1>Notification Detail</h1>
}

export default NotificationDetailPage
